export const ARTIFACT_PATH_NAME = 'artifacts';
